<div class="flex h-dvh flex-col lg:flex-row overflow-hidden">
  <!-- Mobile Header -->
  <div class="lg:hidden p-4 flex justify-between items-center bg-white border-b">
    <div class="flex items-center">
      <h1 class="text-[#BE2F27] font-semibold text-[24px] leading-[100%] tracking-[-0.08em]">bucca</h1>
      <p
        class="text-[#121212] text-[12px] font-medium bg-[#F3F3F3] leading-[160%] px-[10px] py-[5px] rounded-[20px] ml-2">
        {{ roleLabel }}
      </p>
    </div>
    <div class="flex items-center gap-3">
      <div class="relative cursor-pointer">
        <img src="icons/bells.svg" class="w-6 h-6" alt="Notifications" />
      </div>

      <div nz-dropdown [nzDropdownMenu]="mobileProfileMenu" class="cursor-pointer">
        <div
          class="w-9 h-9 flex items-center justify-center bg-[#E6E8EA] rounded-lg text-[#171A1C] font-semibold text-sm">
          {{ userInitials }}
        </div>
      </div>
      <nz-dropdown-menu #mobileProfileMenu="nzDropdownMenu">
        <!-- <ul nz-menu nzSelectable>
          <li nz-menu-item>1st menu item</li>
          <li nz-menu-item>2nd menu item</li>
        </ul> -->
      </nz-dropdown-menu>

      <button nz-button nzType="text" (click)="toggleMobileMenu()" class="text-[#BE2F27] !px-1">
        <span nz-icon nzType="menu"></span>
      </button>
    </div>
  </div>

  <!-- Desktop Sidebar -->
  <div class="hidden lg:block w-[19%] border border-[#E6E6E6] overflow-y-auto hide-scrollbar pt-[19px]">
    <ng-container *ngTemplateOutlet="sidebarContent"></ng-container>
  </div>

  <!-- Mobile Drawer -->
  <nz-drawer [nzVisible]="isMobileMenuOpen" [nzPlacement]="'left'" [nzClosable]="true" [nzWidth]="'280px'"
    (nzOnClose)="closeMobileMenu()" [nzBodyStyle]="{ padding: '0px' }">
    <div *nzDrawerContent class="pt-[19px] h-full overflow-y-auto bg-white">
      <ng-container *ngTemplateOutlet="sidebarContent"></ng-container>
    </div>
  </nz-drawer>

  <!-- Sidebar Content Template -->
  <ng-template #sidebarContent>
    <div class="min-w-[200px]">
      <div class="flex items-center ml-[24px]">
        <h1 class="text-[#BE2F27] font-semibold text-[28px] leading-[100%] tracking-[-0.08em] py-[10px]">
          bucca
        </h1>
        <p
          class="text-[#121212] text-[12px] font-medium bg-[#F3F3F3] leading-[160%] px-[10px] py-[5px] rounded-[20px] ml-2">
          {{ roleLabel }}
        </p>
      </div>
      <hr class="border-[#E6E6E6]" />
      <div class="pt-[24px]">
        <div class="ml-[24px]">
          <p class="flex py-[12.5px] px-[16px] text-[#121212] text-[14px] font-normal">General</p>

          <div>
            <div routerLink="/dashboard" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
              class="flex py-[12.5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer">
              <img src="icons/dashboard.svg" />
              <a class="hover:text-white">Dashboard</a>
            </div>

            <!-- <div routerLink="/orders" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
              class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer">
              <img src="icons/orders.svg" />
              <a class="hover:text-white">Orders</a>
            </div> -->

            <div routerLink="/menu" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
              class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer">
              <img src="icons/vendor.svg" />
              <a class="hover:text-white">Menu</a>
            </div>

            <div routerLink="/payouts" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
              class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer">
              <img src="icons/vendor-payout.svg" />
              <a class="hover:text-white">Revenue</a>
            </div>

            <div routerLink="/ratings" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
              class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
              </svg>
              <a class="hover:text-white">Ratings & Feedback</a>
            </div>

            <div routerLink="/staff-member" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
              class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="7" r="3.2" />
                <path d="M2.5 19.5c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5" />
                <path d="M16 8c1.4.2 2.5 1.4 2.5 2.9S17.4 13.6 16 13.8" />
                <path d="M18.5 14.3c1.7.5 3 1.9 3 3.9v1.3" />
              </svg>
              <a class="hover:text-white">Staff Member</a>
            </div>

            <!-- <div
              routerLink="/transactions"
              routerLinkActive="sidebar-active"
              (click)="closeMobileMenu()"
              class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black active:text-white mr-[20px] rounded-[8px] cursor-pointer"
            >
              <img src="icons/transaction.svg" />
              <a class="hover:text-white">Transactions</a>
            </div> -->
          </div>
        </div>

        <!-- safty -->

        <div class="mt-[12%] mx-[24px] rounded-[8px] p-[20px] bg-gradient-to-b from-[#FFF3F1] to-[#FFFFFF] w-[82%]">
          <div>
            <img src="icons/precaution.svg" />

            <h2 class="text-[#900B09] font-normal text-[11px] leading-[160%] tracking-[24%] mt-[16px]">
              SAFETY PRECAUTION
            </h2>
            <h3 class="font-semibold text-[14px] leading-[140%] tracking-[-2%] text-[#121212]">
              Safe Guard your account
            </h3>
            <p class="font-normal text-[#121212] text-[11px] leading-[160%] w-[88%]">
              Always make sure you logout and lock your pc
            </p>
          </div>
        </div>
        <!-- saftyend -->

        <div class="mx-[24px] mb-[40px]">
          <div routerLink="/settings" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
            class="flex py-[12.5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white mr-[20px] hover:bg-black active:text-white rounded-[8px] cursor-pointer">
            <img src="icons/settings.svg" class="hover:image-white" />
            <a class="hover:text-white">Settings</a>
          </div>

          <!-- <div routerLink="/support" routerLinkActive="sidebar-active" (click)="closeMobileMenu()"
            class="flex py-[12.5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black active:text-white mr-[20px] rounded-[8px] cursor-pointer">
            <img src="icons/support.svg" class="hover:image-white" />
            <a class="hover:text-white">Support</a>
          </div> -->

          <div (click)="closeMobileMenu(); logout()"
            class="mt-2 flex py-[12.5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black active:text-white mr-[20px] rounded-[8px] cursor-pointer">
            <img src="icons/logout.svg" class="hover:image-white" />
            <a class="hover:text-white">Logout</a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- end -->

  <div class="space-y-8 bg-[#FAFAFA] overflow-y-auto hide-scrollbar flex-1 w-full min-h-0 pb-[88px] lg:pb-0">
    <!-- nav -->

    <div class="hidden lg:flex py-[14px] px-[24px] justify-between bg-[#FFFFFF] border-b h-[68px]">
      
        <div class="flex items-center">
          <div class="relative w-full max-w-[414px] hidden sm:block">
            <nz-icon [nzType]="'search'" [nzTheme]="'outline'" [nzSpin]="false"
              class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-lg pointer-events-none"></nz-icon>

            <input
              type="search"
              name="vendor-global-search"
              autocomplete="off"
              nz-input
              placeholder="Search or type a command"
              class="w-[298px] h-[44px] pl-10 pr-4 rounded-[10px] border border-[#E6E6E6] bg-white text-sm placeholder:text-[#98A2B3] focus:border-black focus:ring-1 focus:ring-black" />
          </div>
        </div>

        <div class="flex items-center gap-6">
          <!-- notifications -->
          <div class="relative cursor-pointer">
            <img src="icons/bells.svg" class="w-6 h-6" alt="Notifications" />
          </div>

          <!-- profile -->
          <div nz-dropdown [nzDropdownMenu]="menu" class="flex items-center gap-3 cursor-pointer">
            <div
              class="w-10 h-10 flex items-center justify-center bg-[#E6E8EA] rounded-lg text-[#171A1C] font-semibold text-sm">
              {{ userInitials }}
            </div>
            <div class="flex flex-col hidden sm:flex">
              <h2 class="text-[#121212] font-semibold text-sm leading-tight group">
                {{ userName }}
                <nz-icon nzType="down" class="text-[10px] ml-1 text-gray-400" />
              </h2>
              <h3 class="text-[#F59E0B] font-medium text-[11px] leading-tight">
                {{ roleLabel }}
              </h3>
            </div>
          </div>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <!-- <ul nz-menu nzSelectable>
              <li nz-menu-item>1st menu item</li>
              <li nz-menu-item>2nd menu item</li>
            </ul> -->
          </nz-dropdown-menu>
        </div>
      </div>

      <!-- nav-end -->

      <div class="p-4 lg:p-0">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- Mobile Bottom Navigation -->
    <nav class="mobile-bottom-nav lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#E6E6E6]"
      aria-label="Main navigation">
      <div class="relative h-[68px] px-2">
        <div class="grid grid-cols-5 h-full items-end pb-2">
          <!-- Home -->
          <a routerLink="/dashboard"
            class="mobile-bottom-nav__item flex flex-col items-center justify-end gap-1 py-1 no-underline"
            [ngClass]="isMobileNavActive('/dashboard') ? 'text-[#101828]' : 'text-[#9CA3AF]'">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 10.5L12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5H15v-6h-6v6H5.5A1.5 1.5 0 0 1 4 19v-8.5Z"
                [attr.fill]="isMobileNavActive('/dashboard') ? '#101828' : 'none'"
                [attr.stroke]="isMobileNavActive('/dashboard') ? '#101828' : '#9CA3AF'" stroke-width="1.5"
                stroke-linejoin="round" />
              <path *ngIf="isMobileNavActive('/dashboard')" d="M9.5 14.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5"
                stroke="#fff" stroke-width="1.2" stroke-linecap="round" />
            </svg>
            <span class="text-[11px] leading-none" [class.font-semibold]="isMobileNavActive('/dashboard')">Home</span>
          </a>

          <!-- Menu -->
          <a routerLink="/menu"
            class="mobile-bottom-nav__item flex flex-col items-center justify-end gap-1 py-1 no-underline"
            [ngClass]="isMobileNavActive('/menu') ? 'text-[#101828]' : 'text-[#9CA3AF]'">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 14c0 2.2 1.8 4 4 4h4c2.2 0 4-1.8 4-4v-1H6v1Z"
                [attr.stroke]="isMobileNavActive('/menu') ? '#101828' : '#9CA3AF'" stroke-width="1.5"
                stroke-linejoin="round" />
              <path d="M8 9c0-2.2 1.8-4 4-4s4 1.8 4 4"
                [attr.stroke]="isMobileNavActive('/menu') ? '#101828' : '#9CA3AF'" stroke-width="1.5"
                stroke-linecap="round" />
              <path d="M10 9h4M9 12h6" [attr.stroke]="isMobileNavActive('/menu') ? '#101828' : '#9CA3AF'"
                stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <span class="text-[11px] leading-none" [class.font-semibold]="isMobileNavActive('/menu')">menu</span>
          </a>

          <!-- Spacer for center FAB -->
          <div aria-hidden="true"></div>

          <!-- Revenue -->
          <a routerLink="/payouts"
            class="mobile-bottom-nav__item flex flex-col items-center justify-end gap-1 py-1 no-underline"
            [ngClass]="isMobileNavActive('/payouts') ? 'text-[#101828]' : 'text-[#9CA3AF]'">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="3" y="6" width="18" height="12" rx="2"
                [attr.stroke]="isMobileNavActive('/payouts') ? '#101828' : '#9CA3AF'" stroke-width="1.5" />
              <circle cx="12" cy="12" r="2.5" [attr.stroke]="isMobileNavActive('/payouts') ? '#101828' : '#9CA3AF'"
                stroke-width="1.5" />
              <path d="M7 10h2M15 14h2" [attr.stroke]="isMobileNavActive('/payouts') ? '#101828' : '#9CA3AF'"
                stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <span class="text-[11px] leading-none" [class.font-semibold]="isMobileNavActive('/payouts')">revenue</span>
          </a>

          <!-- Account -->
          <a routerLink="/settings"
            class="mobile-bottom-nav__item flex flex-col items-center justify-end gap-1 py-1 no-underline"
            [ngClass]="isMobileNavActive('/settings') ? 'text-[#101828]' : 'text-[#9CA3AF]'">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="12" cy="8" r="3.5" [attr.stroke]="isMobileNavActive('/settings') ? '#101828' : '#9CA3AF'"
                stroke-width="1.5" />
              <path d="M5.5 19c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5"
                [attr.stroke]="isMobileNavActive('/settings') ? '#101828' : '#9CA3AF'" stroke-width="1.5"
                stroke-linecap="round" />
            </svg>
            <span class="text-[11px] leading-none" [class.font-semibold]="isMobileNavActive('/settings')">account</span>
          </a>
        </div>

        <!-- Center QR / Redeem -->
        <button type="button" (click)="openRedeemModal()"
          class="mobile-bottom-nav__fab absolute left-1/2 -translate-x-1/2 -top-5 w-[56px] h-[56px] rounded-full bg-[#BE2F27] border-[4px] border-white flex items-center justify-center"
          aria-label="Redeem booking">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.41667 5.41667H5.425M14.5833 5.41667H14.5917M5.41667 14.5833H5.425M10.8333 10.8333H10.8417M14.5833 14.5833H14.5917M14.1667 17.5H17.5V14.1667M11.6667 13.75V17.5M17.5 11.6667H13.75M13 8.33333H16.1667C16.6334 8.33333 16.8667 8.33333 17.045 8.24251C17.2018 8.16261 17.3293 8.03513 17.4092 7.87833C17.5 7.70007 17.5 7.46671 17.5 7V3.83333C17.5 3.36662 17.5 3.13327 17.4092 2.95501C17.3293 2.79821 17.2018 2.67072 17.045 2.59083C16.8667 2.5 16.6334 2.5 16.1667 2.5H13C12.5333 2.5 12.2999 2.5 12.1217 2.59083C11.9649 2.67072 11.8374 2.79821 11.7575 2.95501C11.6667 3.13327 11.6667 3.36662 11.6667 3.83333V7C11.6667 7.46671 11.6667 7.70007 11.7575 7.87833C11.8374 8.03513 11.9649 8.16261 12.1217 8.24251C12.2999 8.33333 12.5333 8.33333 13 8.33333ZM3.83333 8.33333H7C7.46671 8.33333 7.70007 8.33333 7.87833 8.24251C8.03513 8.16261 8.16261 8.03513 8.24251 7.87833C8.33333 7.70007 8.33333 7.46671 8.33333 7V3.83333C8.33333 3.36662 8.33333 3.13327 8.24251 2.95501C8.16261 2.79821 8.03513 2.67072 7.87833 2.59083C7.70007 2.5 7.46671 2.5 7 2.5H3.83333C3.36662 2.5 3.13327 2.5 2.95501 2.59083C2.79821 2.67072 2.67072 2.79821 2.59083 2.95501C2.5 3.13327 2.5 3.36662 2.5 3.83333V7C2.5 7.46671 2.5 7.70007 2.59083 7.87833C2.67072 8.03513 2.79821 8.16261 2.95501 8.24251C3.13327 8.33333 3.36662 8.33333 3.83333 8.33333ZM3.83333 17.5H7C7.46671 17.5 7.70007 17.5 7.87833 17.4092C8.03513 17.3293 8.16261 17.2018 8.24251 17.045C8.33333 16.8667 8.33333 16.6334 8.33333 16.1667V13C8.33333 12.5333 8.33333 12.2999 8.24251 12.1217C8.16261 11.9649 8.03513 11.8374 7.87833 11.7575C7.70007 11.6667 7.46671 11.6667 7 11.6667H3.83333C3.36662 11.6667 3.13327 11.6667 2.95501 11.7575C2.79821 11.8374 2.67072 11.9649 2.59083 12.1217C2.5 12.2999 2.5 12.5333 2.5 13V16.1667C2.5 16.6334 2.5 16.8667 2.59083 17.045C2.67072 17.2018 2.79821 17.3293 2.95501 17.4092C3.13327 17.5 3.36662 17.5 3.83333 17.5Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </button>
      </div>
    </nav>

    <app-redeem-booking-modal *ngIf="isRedeemModalOpen" (close)="closeRedeemModal()"
      (redeemed)="onBookingRedeemed($event)"></app-redeem-booking-modal>

    <!-- Logout Confirmation Modal -->
    <div *ngIf="isLogoutModalVisible"
      class="fixed inset-0 bg-black/40 backdrop-blur-xs flex items-center justify-center z-[9999] p-4">
      <div
        class="bg-white max-w-[400px] w-full rounded-[16px] border border-[#E6E6E6] p-[24px] shadow-[0px_8px_32px_rgba(0,0,0,0.08)] relative">
        <!-- Close Button -->
        <button
          class="absolute top-4 right-4 w-[28px] h-[28px] rounded-full border border-[#E5E5E5] flex items-center justify-center text-[#1A1A1A] hover:bg-gray-50 transition-colors"
          (click)="isLogoutModalVisible = false">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>

        <!-- Header -->
        <div class="flex flex-col items-center text-center mt-2 mb-6">
          <div class="w-[48px] h-[48px] rounded-full bg-[#FEE4E2] text-[#D92D20] flex items-center justify-center mb-4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </div>
          <h3 class="text-[18px] font-semibold text-[#121212]">Confirm Logout</h3>
          <p class="text-[14px] text-[#6A6A6A] mt-2">Are you sure you want to log out of your account?</p>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-[12px]">
          <button type="button"
            class="flex-1 py-[12px] rounded-[10px] border border-[#E5E5E5] text-[14px] font-medium text-[#1A1A1A] hover:bg-gray-50 transition-colors cursor-pointer text-center"
            (click)="isLogoutModalVisible = false">
            Cancel
          </button>
          <button type="button"
            class="flex-1 py-[12px] rounded-[10px] bg-[#BE2F27] text-white text-[14px] font-medium hover:bg-[#a12821] transition-colors cursor-pointer text-center"
            (click)="confirmLogout()">
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>